<div class="check-line">
    <div>
        <img src="assets/img/people.svg" alt="people">
        <div class="text title" [innerHTML]="title | safeHtml"></div>
    </div>
    <div>
        <div class="text">{{'__JOURNEY_CONFIRM__' | translate}}</div>
        <ion-checkbox class="My-checkbox" [(ngModel)]="this.details.attend_need"
                      (click)="changeAttendance(!this.details.attend_need)"></ion-checkbox>
    </div>
</div>
